// Persited vUEX Secured
import SecureLS from "secure-ls";
import createPersistedState from "vuex-persistedstate"

var ls = new SecureLS({
  encodingType: "aes",
  isCompression: false,
  encryptionSecret: "201913TS"
});

export default createPersistedState({
  key: 'vuexs',
  storage: {
    getItem: key => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: key => ls.remove(key)
  }
})